import React, { Children } from "react";
import LoadingOverlay from "react-loading-overlay";
import { HashLoader, SquareLoader } from "react-spinners";

export default function Spinner({ active, children }) {
  return (
    <>
      <LoadingOverlay
        active={active}
        spinner={
          <SquareLoader
          //   color='#164e63'
          />
        }
      >
        {children}
      </LoadingOverlay>
    </>
  );
}
